<template>
  <span
    :class="{ 'ocn-Name-hidden': !userHasReadAccess, 'ocn-Name-clickable': canBeClicked }"
    class="ocn-Name"
    @click.stop="onClick"
  >
    {{ displayText }}
  </span>
</template>

<script setup>
import { computed } from 'vue'

import { currentUserCanReadObjective, currentUserCanUpdateObjective } from '@/utils/objectives'

defineOptions({
  name: 'OkrElementCipheredName'
})

const props = defineProps({
  okrElement: {
    type: Object,
    required: true
  },

  clickable: {
    type: Boolean,
    default: false
  }
})

const userHasReadAccess = computed(() => {
  return currentUserCanReadObjective(props.okrElement)
})

const userHasUpdateAccess = computed(() => {
  return currentUserCanUpdateObjective(props.okrElement)
})

const displayText = computed(() => {
  return userHasReadAccess.value ? props.okrElement.name : '∗∗∗∗∗∗∗∗∗∗∗'
})

const emit = defineEmits({
  click: null
})

const canBeClicked = computed(() => {
  return props.clickable && userHasUpdateAccess.value
})

const onClick = () => {
  if (canBeClicked.value) emit('click')
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/ciphered-text';

.ocn-Name {
  &-hidden {
    @include cipheredText(
      var(--text-color, #{$primary-color-next}),
      var(--overlay-color, #{$white})
    );
  }

  &-clickable {
    @media (any-hover: hover) {
      &:hover {
        text-decoration: underline;
        color: $primary-color-next;
        cursor: pointer;
      }
    }
  }
}
</style>
